import { render, staticRenderFns } from "./riskDetail.vue?vue&type=template&id=659bc595"
import script from "./riskDetail.vue?vue&type=script&lang=js"
export * from "./riskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('659bc595')) {
      api.createRecord('659bc595', component.options)
    } else {
      api.reload('659bc595', component.options)
    }
    module.hot.accept("./riskDetail.vue?vue&type=template&id=659bc595", function () {
      api.rerender('659bc595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/riskDetail.vue"
export default component.exports